<template>
    <div class="">
        <transition name="shrink">
            <div v-if="error" class="pb-14" style="max-height: 65px;">
                <p
                    class="fixed top-0 left-0 z-30 w-full px-6 py-3 text-center text-white bg-red-500 small"
                >
                    {{ error }}
                </p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data: () => ({
        error: null
    }),

    mounted() {
        window.errors = [];
        window.setInterval(() => {
            this.getErrors();
        }, 1000);
    },

    methods: {
        getErrors() {
            if (!this.error && window.errors.length) {
                this.error = window.errors.pop();
                this.dequeueError();
            }
        },
        dequeueError() {
            window.setTimeout(() => (this.error = null), 8000);
        }
    }
};
</script>
